import { v4 as uuidv4 } from "uuid";
import { faker } from "@faker-js/faker";
import defaultValuesOld from "../scenarios/edu-scenarios";

const names = defaultValuesOld().serverGroups;

const addData = (item, type) => {
  let desc = item.Description;
  let name = item.Name;
  let instances = faker.number.int({ max: 5 });
  if (type) {
    instances = item.InstanceIds.length;
  }
  return {
    Name: name,
    ServerGroupId: uuidv4(),
    CompliantInstanceCount: instances,
    CompliancePercentage: faker.number.int({ min: 10, max: 70 }),
    Instances: instances,
    Description: desc,
    WindowsCount: faker.number.int({ min: 10, max: 20 }),
    LinuxCount: faker.number.int({ min: 10, max: 20 }),
    ManagedCount: faker.number.int({ min: 10, max: 20 }),
    UnmanagedCount: faker.number.int({ min: 10, max: 20 }),
  };
};

export const allServerGroups = () => {
  let serverGroups = [];
  names.forEach((item) => {
    serverGroups.push(addData(item));
  });
  return serverGroups;
};

export const createServerGroup = (data) => {
  return addData(data, "new");
};
